"use client";

import { Alert, AlertDescription } from "@/components/ui/alert";
import type { TenantCode } from "@/config/tenants";
import { AuthCard } from "@/features/auth/components/auth-card";
import { AuthDivider } from "@/features/auth/components/auth-divider";
import { AuthLegalLinks } from "@/features/auth/components/auth-legal-links";
import { MagicLinkForm } from "@/features/auth/components/magic-link-form";
import { SocialAuthButtons } from "@/features/auth/components/social-auth-buttons";
import { authCopy } from "@/features/auth/content/auth-copy";
import { useAppLocale } from "@/features/localization/app-locale-provider";

interface LoginCardProps {
  oauthError?: string;
  tenantCode: TenantCode;
}

export function LoginCard({ oauthError, tenantCode }: Readonly<LoginCardProps>) {
  const { locale } = useAppLocale();
  const copy = authCopy[locale];

  return (
    <AuthCard title={copy.signIn.title}>
      <div className="space-y-6 xl:[@media(max-height:800px)]:space-y-5">
        {oauthError === "google" ? (
          <Alert aria-live="polite" role="alert">
            <AlertDescription>{copy.signIn.errors.google}</AlertDescription>
          </Alert>
        ) : null}
        <SocialAuthButtons tenantCode={tenantCode} />
        <AuthDivider />
        <MagicLinkForm tenantCode={tenantCode} />
        <AuthLegalLinks tenantCode={tenantCode} />
      </div>
    </AuthCard>
  );
}
